<template>
  <div class="comingsoon buildhome" v-if="client">
    <div class="side">
      <img @click="goTo('/')" class="logo" :src="client.logo" />
      <h2>{{ build_homes && build_homes.title ? build_homes.title : "Build a Home" }}</h2>
      <p>{{ build_homes && build_homes.description ? build_homes.description : "Built homes" }}</p>
      <div class="navs">
        <div
          class="nav"
          :style="{
            backgroundColor: client.color &&  client.color.primary
              ? '#' + client.color.primary
              : '#F26638',
          }"
          @click="goTo('/newhomes')"
        >
          <p>New Homes</p>
          <img src="@/assets/img/next.svg" />
        </div>
        <div
          class="nav"
          :style="{
            backgroundColor: client.color &&  client.color.primary
              ? '#' + client.color.primary
              : '#F26638',
          }"
          @click="goTo('/legacyhomes')"
        >
          <p>Legacy Homes</p>
          <img src="@/assets/img/next.svg" />
        </div>
      </div>
    </div>
    <template v-if="build_homes && build_homes.images && build_homes.images.length">
      <div class="gallery">
        <div
          v-for="(item, i) in build_homes.images"
          @click="showImages(i)"
          class="image"
          :style="{ backgroundImage: 'url(' + item.url + ')' }"
        ></div>
      </div>
    </template>
    <template v-if="!build_homes || (build_homes && !build_homes.images.length)">
      <div class="gallery no-listings">
        <img src="@/assets/img/no-photo.svg" />
        <p>There are currently no new listings</p>
      </div>
    </template>

    <transition name="fade">
      <slider ref="slider" v-if="show_images" :slides="build_homes.images" :show_text="true"></slider>
    </transition>
  </div>
</template>

<script>
import { db, functions, analytics } from "@/config/firebaseInit";
import Slider from "@/components/Slider";

export default {
  name: "home",
  components: {
    Slider
  },
  data() {
    return {
      client: this.$store.state.client,
      user: this.$store.state.user,
      build_homes: this.$store.state.build_homes,
      show_images: false
    };
  },
  mounted() {},
  async created() {},
  watch: {},
  methods: {
    showImages(index) {
      this.show_images = true;
      setTimeout(() => {
        this.$refs.slider.current_index = index;
      }, 100);
    }
  }
};
</script>

<style lang="scss">
.comingsoon {
  height: 100vh;
  width: 100vw;
  display: flex;
  .side {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 500px;
    padding: 100px;
    flex: none;
    .logo {
      width: 275px;
      margin: auto;
      margin-top: 50px;
      margin-bottom: 30px;
    }
    h2 {
      color: black;
      font-size: 51px;
      margin-bottom: 0;
    }
    p {
      font-size: 23px;
    }
  }
  .gallery {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    padding: 30px;
    .image {
      width: 32%;
      height: 323px;
      margin-bottom: 25px;
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
}
</style>
